
export async function dropdownInit() {
    /**
     * Dropdowns
     */
    const dropdownTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'));
    let {default: Dropdown} = await import('bootstrap/js/dist/dropdown');
    const dropdownList = dropdownTriggerList.map(async (dropdownTriggerEl) => {
        const d = new Dropdown(dropdownTriggerEl);
        dropdownTriggerEl.addEventListener('click', () => {
            d.show()
        })
    });
}
 